import StrategyManage from './index';
import Supplier from './supplier';
import HistorySignals from './supplier/historySignals';
import SubManage from './subManage';
import SubRecord from './subRecord';

export default {
    path: 'home/strategy/',
    component: StrategyManage,
    children: [
        {path: '/home/strategy/supplier', component: Supplier},
        {path: '/home/strategy/supplier/historySignals', component: HistorySignals},
        {path: '/home/strategy/subManage', component: SubManage},
        {path: '/home/strategy/subRecord', component: SubRecord},
    ]
}
